import { createContext, useContext, useState, useCallback } from "react"
import type { ReactNode } from "react"
import { DocsModal } from "@/components/docs-modal"

interface DocsContextType {
  openDocs: (sectionId?: string) => void
  closeDocs: () => void
  isOpen: boolean
}

const DocsContext = createContext<DocsContextType | undefined>(undefined)

export function DocsProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)
  const [defaultSection, setDefaultSection] = useState("getting-started")

  const openDocs = useCallback((sectionId?: string) => {
    setDefaultSection(sectionId || "getting-started")
    setIsOpen(true)
  }, [])

  const closeDocs = useCallback(() => {
    setIsOpen(false)
  }, [])

  return (
    <DocsContext.Provider value={{ openDocs, closeDocs, isOpen }}>
      {children}
      <DocsModal
        open={isOpen}
        onOpenChange={setIsOpen}
        defaultSection={defaultSection}
      />
    </DocsContext.Provider>
  )
}

export function useDocs() {
  const context = useContext(DocsContext)
  if (!context) {
    throw new Error("useDocs must be used within a DocsProvider")
  }
  return context
}
